
export default function (Component) {
  Component.options.__source = "src/components/Pages/layout/PageEditLayout.vue"
}
